export const HEADER_TYPES_INITIAL_VALUES = {
  NONE: null,
  TEXT: {
    type: "HEADER",
    format: "TEXT",
    text: "",
  },
  MEDIA: {
    type: "HEADER",
    format: "MEDIA",
    example: {
      header_handle: [""],
    },
  },
  IMAGE: {
    type: "HEADER",
    format: "IMAGE",
    example: {},
  },
  VIDEO: {
    type: "HEADER",
    format: "VIDEO",
    example: {},
  },
  DOCUMENT: {
    type: "HEADER",
    format: "DOCUMENT",
    example: {},
  },
};

export const ADD_VARIABLE_OPTIONS = [
  {
    id: 1,
    value: "{{first-name}}",
    label: "first-name",
  },
  {
    id: 2,
    value: "{{last-name}}",
    label: "last-name",
  },
  {
    id: 3,
    value: "{{shop-name}}",
    label: "shop-name",
  },
  {
    id: 4,
    value: "{{email-id}}",
    label: "email-id",
  },
  {
    id: 5,
    value: "{{mobile-number}}",
    label: "mobile-number",
  },
  {
    id: 6,
    value: "{{custom-variable}}",
    label: "custom-variable",
  },
];

export const carouselButtonOptions = {
  URL: "Visit Website",
  PHONE_NUMBER: "Call Phone Number",
  CUSTOM: "Quick Reply",
  NONE: "None",
};

export const templateLanguages = [
  { id: 1, name: "English", value: "en" },
  { id: 2, name: "English_US", value: "en_US" },
  { id: 3, name: "Tamil", value: "ta" },
  { id: 4, name: "English_US", value: "en_GB" },
  { id: 5, name: "Telugu", value: "te" },
  { id: 6, name: "Kannada", value: "kn" },
  { id: 7, name: "Bengali", value: "bn" },
  { id: 8, name: "Hindi", value: "hi" },
  { id: 9, name: "Marathi", value: "mr" },
  { id: 10, name: "Malayalam", value: "ml" },
];
